import Swiper, { Navigation, A11y } from 'swiper';
import {fetchSlots, getLocalTimezone} from "./widget-online";
import {DateTime} from "luxon";

function IframeCalendar (calendarNode) {
    this.serviceId = null;
    this.modal = calendarNode;
    this.serviceItems = this.modal.querySelectorAll('.modal-widget-mobile-head-service-item');
    this.loadingService = false;
    this.initialServiceId = parseInt(this.modal.dataset.initialServiceId);
    this.serviceSlots = {};
    this.filledServiceSlotsCount = 0;
    this.day = null;
    this.swiper = null;
    this.hour = null;
    this.maxRows = this.serviceItems.length >= 2 ? 2 : 3;
    this.breakpointConfig = this.modal.dataset.breakpointConfig;
    this.showAllHours = this.modal.dataset.allHours;
    this.overrideRows = this.modal.dataset.overrideRows;

    let allServicesId = this.modal.dataset.servicesId;
    if (allServicesId) {
        this.allServiceIds = allServicesId.split(',').map(el => parseInt(el));
    } else {
        this.allServiceIds = [];
    }


    let userId = this.modal.dataset.userId;
    if (!userId || 0 === userId.length) {
        throw new Error('user id is not specified');
    }
    this.userId = parseInt(userId);
    this.userSlug = this.modal.dataset.userSlug;
    this.userName = this.modal.dataset.userName;

    this.serviceItems.forEach(el => el.addEventListener('click', e => {
        if (this.loadingService) {
            return;
        }

        this.loadCalendar(parseInt(el.dataset.serviceId));
        this.serviceItems.forEach(serviceItem => { serviceItem.classList.remove('active'); })
        el.classList.add('active');
    }));

    this.loadCalendar = (serviceId) => {
        if (null === this.modal) {
            return;
        }

        if (serviceId === this.serviceId) {
            return;
        }

        if ('1' != this.modal.dataset.calendarEnabled) {
            return;
        }

        if (this.allServiceIds.length == 0) {
            this.modal.classList.remove('shimmering');
            this.showEmptySlots();
            return;
        }

        this.modal.classList.add('modal-widget-mobile-loading');
        this.loadingService = true;

        this.serviceId = serviceId;
        if (!(this.serviceId in this.serviceSlots)) {
            this.serviceSlots[this.serviceId] = {};
            fetchSlots(this.userId, this.serviceId, this.fillSlots);
        } else {
            this.processSlots(this.serviceSlots[this.serviceId]);
        }
        this.loadOtherServices();
    };

    this.fillSlots = (slots, serviceId, callback = this.processSlots) => {
        let currentDate = null;
        let lastDate = null;
        for (const ameliaDay in slots) {
            for (const hour in slots[ameliaDay]) {
                let date = DateTime.fromFormat(
                    `${ameliaDay} ${hour} Europe/Warsaw`,
                    "yyyy-MM-dd HH:mm z"
                ).setZone(getLocalTimezone());

                if (null === currentDate) {
                    currentDate = date;
                }
                lastDate = date;

                const day = date.toFormat('y-LL-dd');
                if (!(day in this.serviceSlots[serviceId])) {
                    this.serviceSlots[serviceId][day] = [];
                }
                this.serviceSlots[serviceId][day].push(date.toFormat('HH:mm'));
            }
        }

        if (null !== currentDate) {
            let cursor = currentDate.startOf("day");
            while (cursor < lastDate) {
                const dateF = cursor.toFormat('y-LL-dd');
                if (!(dateF in this.serviceSlots[serviceId])) {
                    this.serviceSlots[serviceId][dateF] = [];
                }
                cursor = cursor.plus({ days: 1 });
            }
        }


        if (callback) {
            callback(this.serviceSlots[serviceId]);
        }

        ++this.filledServiceSlotsCount;

        if (this.filledServiceSlotsCount === this.allServiceIds.length) {
            this.allServiceSlotsFilled();
        }
    };

    this.processSlots = slots => {
        this.modal.querySelectorAll('.modal-widget-mobile-dates-item.active').forEach(el => el.classList.remove('active'));
        this.modal.querySelector('.modal-widget-mobile-dates .swiper-wrapper').innerHTML = '';
        this.modal.querySelector('.modal-widget-mobile-dates-wrapper').classList.remove('transitions-enabled');
        this.modal.classList.remove('shimmering');
        if (null !== this.swiper) {
            this.swiper.destroy();
        }

        let idx = 0;
        let activeIndex = null;
        for (let day of Object.keys(slots).sort()) {
            let dayDiv = document.createElement('div');
            dayDiv.className = 'modal-widget-mobile-dates-item swiper-slide';

            let date = DateTime.fromFormat(
                day,
                "yyyy-MM-dd"
            ).setLocale('pl');

            let dayName = 'Jutro';

            if ((date - DateTime.now()) / 3600000 >= 24) {
                dayName = date.toFormat('ccc').replace('.', '').replace('niedz', 'ndz');
            }

            dayDiv.innerHTML = '<span>' + dayName + '<br>' + date.toFormat('d.LL') + '</span>';

            if (null === this.day || day === this.day || !(this.day in slots)) {
                this.day = day;
                dayDiv.className += ' active';
                activeIndex = idx;
            }
            if (slots[day].length === 0) {
                dayDiv.className += ' empty';
            }

            dayDiv.addEventListener('click', () => {
                this.modal.querySelectorAll('.modal-widget-mobile-dates-item.active').forEach(el => el.classList.remove('active'));
                this.day = day;
                dayDiv.classList.add('active');
                this.fillHours();
            });

            this.modal.querySelector('.modal-widget-mobile-dates .swiper-wrapper').appendChild(dayDiv);
            idx++;
        }

        if (Object.keys(slots).length === 0) {
            this.showEmptySlots();
        } else {
            this.modal.classList.remove('empty');

            this.fillHours();

            this.loadSwiper();

            if (activeIndex) {
                this.swiper.slideTo(activeIndex, 0, false);
            }
        }

        this.modal.classList.remove('modal-widget-mobile-loading');
        this.loadingService = false;
    };

    this.deSelectAllDays = () => {
        // deselect days
        this.modal.querySelectorAll('.modal-widget-mobile-dates-item.active').forEach(el => el.classList.remove('active'));
        this.day = null;

        // hide hours and buttons
        this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '0';
        setTimeout(() => {
            this.modal.querySelector('.modal-widget-mobile-buttons-item.more-hours')?.classList.add('d-none');
            this.modal.querySelector('.modal-widget-mobile-buttons-item.booking').classList.add('d-none');
            this.showEmptyRange();
            this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '1';
        }, 100);
    };

    this.fillHours = () => {
        this.hour = null;

        this.modal.querySelector('.modal-widget-mobile-hours').classList.remove('empty');
        this.modal.querySelector('.modal-widget-mobile-info-wrapper').classList.remove('empty');

        let hourIter = 0;
        let hoursFragment = document.createDocumentFragment();
        let showMoreHours = false;
        for (let hour of this.serviceSlots[this.serviceId][this.day]) {
            let maxRows = this.maxRows;
            if (this.overrideRows > 0) {
                maxRows = parseInt(this.overrideRows);
                showMoreHours = true;
            }
            if (hourIter >= maxRows * 4 &&  '0' == this.showAllHours) {
                showMoreHours = true;
                break;
            }
            let hourDiv = document.createElement('div');

            hourDiv.className = 'modal-widget-mobile-hours-item col-3';

            if (null === this.hour) {
                this.hour = hour;
                hourDiv.className += ' active';
                this.updateLink();
            }
            hourDiv.dataset.hour = hour;

            hourDiv.addEventListener('click', () => {
                this.modal.querySelectorAll('.modal-widget-mobile-hours-item.active').forEach(el => el.classList.remove('active'));
                this.hour = hour;
                hourDiv.classList.add('active');

                this.updateLink();
            });
            hoursFragment.appendChild(hourDiv);
            hourIter++;
        }
        if (hourIter == 0) {
            this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '0';
            setTimeout(() => {
                this.modal.querySelector('.modal-widget-mobile-buttons-item.more-hours')?.classList.add('d-none');
                this.modal.querySelector('.modal-widget-mobile-buttons-item.booking').classList.add('d-none');
                this.showEmptySlots(this.day);
                this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '1';
            }, 100);
        } else {

            this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '0';
            setTimeout(() => {
                this.modal.querySelector('.modal-widget-mobile-hours .row').innerHTML = '';
                this.modal.querySelector('.modal-widget-mobile-buttons-item.booking').classList.remove('d-none');
                if (showMoreHours) {
                    this.modal.querySelector('.modal-widget-mobile-buttons-item.more-hours')?.classList.remove('d-none');
                } else {
                    this.modal.querySelector('.modal-widget-mobile-buttons-item.more-hours')?.classList.add('d-none');
                }
                this.modal.querySelector('.modal-widget-mobile-hours .row').appendChild(hoursFragment);
                this.modal.querySelector('.modal-widget-mobile-hours').style.opacity = '1';
            }, 100);

        }
    };

    this.renderEmptyWidget = errorString => {
        this.modal.querySelector('.modal-widget-mobile-info-wrapper').classList.add('empty');
        this.modal.querySelector('.modal-widget-mobile-hours').classList.add('empty');
        this.modal.querySelector('.modal-widget-mobile-hours .row').innerHTML = `
                <div class="col-12">
                    <div class="modal-widget-mobile-hours-empty">
                        ${errorString}
                    </div>
                </div>
            `;
    };

    this.showEmptySlots = (day = null) => {
        let errorString = '';
        if (null !== day) {
            let date = DateTime.fromFormat(
                day,
                "yyyy-MM-dd"
            ).setLocale('pl');
            const dayName = date.toFormat('cccc').replace('.', '').replace('niedz', 'ndz');
            errorString = dayName + ', ' + date.toFormat('d LLLL') + '<br><span class="font-weight-bold">brak wolnych terminów</span>';
        } else {
            errorString = '<span class="font-weight-bold">' + this.userName + '</span> ma wyłączoną możliwość umawiania wizyt przez internet';
        }
        this.renderEmptyWidget(errorString);
    }
    this.showEmptyRange = () => {
        let errorString = 'Wybierz zakres, w którym logopeda ma wolne terminy';
        this.renderEmptyWidget(errorString);
    }

    this.loadOtherServices = () => {
        for (let serviceId of this.allServiceIds) {
            if (serviceId === this.serviceId) {
                continue;
            }

            if (!(serviceId in this.serviceSlots)) {
                this.serviceSlots[serviceId] = {};
                fetchSlots(this.userId, serviceId, (slots, serviceCallbackId) => {
                    this.fillSlots(slots, serviceCallbackId, null);
                });
            }
        }
    };

    this.updateLink = () => {
        let date = DateTime.fromFormat(
            this.day + ' ' + this.hour,
            "yyyy-MM-dd HH:mm"
        ).setLocale('pl').setZone('Europe/Warsaw');

        let linkDate = date.toFormat('yyyy-LL-dd+HH:mm:\'00\'');

        let link = window.location.protocol + "//" + window.location.host + '/umow-wizyte/' + this.userSlug;
        link += `?serviceId=${this.serviceId}&date=${linkDate}&ep=${this.modal.dataset.ep}`;

        this.modal.querySelector('.modal-widget-mobile-buttons-item.booking').href = link;
    };

    this.loadSwiper = () => {

        let breakpoints = {
            370: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        };

        if (['under_post', 'expert_top'].includes(this.breakpointConfig)) {
            breakpoints = {
                1200: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            };
        } else if ('expert_content' === this.breakpointConfig) {
            breakpoints = {
                420: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
            };
        } else if (['free_recommended'].includes(this.breakpointConfig)) {
            breakpoints = {
                450: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
            };
        }

        this.swiper = new Swiper(this.modal.querySelector('.swiper'), {
            speed: 300,
            modules: [Navigation, A11y],
            navigation: {
                nextEl: `[data-user-id="${this.userId}"] .swiper-button-next`,
                prevEl: `[data-user-id="${this.userId}"] .swiper-button-prev`,
            },
            a11y: {
                notificationClass: 'sr-only',
            },
            grabCursor: true,
            watchOverflow: true,
            slidesPerView: 3,
            slidesPerGroup: 3,
            breakpoints: breakpoints,
            slidesPerColumnFill: 'row',
            spaceBetween: 16,
            on: {
                init: () => {
                    this.modal.querySelector('.modal-widget-mobile-dates-wrapper').classList.add('slides-ready');

                    setTimeout(() => {
                        this.modal.querySelector('.modal-widget-mobile-dates-wrapper').classList.add('transitions-enabled');
                    }, 100);
                },
            },
        });

        this.swiper.on('slideChangeTransitionEnd', () => {
            const activeIndex = this.swiper.activeIndex;
            const slidesPerView = this.swiper.params.slidesPerView;
            let foundNotEmpty = false;
            this.modal.querySelectorAll('.modal-widget-mobile-dates-item').forEach((e, idx) => {
                if (idx < activeIndex || idx >= activeIndex + slidesPerView) {
                    return;
                }
                if (e.classList.contains('empty') || foundNotEmpty) {
                    return;
                }
                e.click();
                foundNotEmpty = true;
            });
            if (false === foundNotEmpty) {
                this.deSelectAllDays();
            }
        });
    };

    this.allServiceSlotsFilled = () => {
        if (this.initialServiceId !== this.serviceId) {
            return;
        }

        let hasInitialServiceEmptySlots = Object.values(this.serviceSlots[this.serviceId]).length === 0;
        let serviceIdWithNonEmptySlots = null;

        if (!hasInitialServiceEmptySlots) {
            return;
        }

        Object.entries(this.serviceSlots).forEach(entry => {
            if (serviceIdWithNonEmptySlots) {
                return;
            }

            let serviceId = entry[0], slots = entry[1];

            if (Object.values(slots).length > 0) {
                serviceIdWithNonEmptySlots = serviceId;
            }
        });

        if (!serviceIdWithNonEmptySlots) {
            return;
        }

        this.modal.classList.remove('empty');

        this.serviceItems.forEach(serviceItem => {
            if (serviceItem.dataset.serviceId == this.serviceId) {
                serviceItem.hidden = true;
            }

            if (serviceItem.dataset.serviceId == serviceIdWithNonEmptySlots) {
                serviceItem.click();
            }
        });
    };
}

window.addEventListener('load', () => {
    for (let calendarNode of document.querySelectorAll('.modal-widget-mobile-container')) {
        let calendar = new IframeCalendar(calendarNode);
        calendar.loadCalendar(calendar.initialServiceId);
    }
});
